/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */
/* eslint-disable hubspot-dev/no-unsafe-storage */

'use es6';

import ContentRoutes from 'ContentUtils/Routes';
import { syncInpageState, trackedFailedInpageAssets, trackedInpageJsLoadingMultipleTimes } from 'ContentEditorUI/redux/actions/inpageActions';
import EventBus from 'InpageEditorUI/lib/EventBus';
import { attachCritialAssetHandler, collectAndFinishWaitingForCritialAssets, attachSlowDomReadyHandler, attachRedirectDetector, detachRedirectDetector } from 'InpageEditorUI/lib/detectCriticalFailures';
import { inpagePreviewUnexpectedlyUnloaded, domReadyBlockingResourceDetected } from 'ContentEditorUI/redux/actions/inpageActions';
import EditController from 'InpageEditorUI/controllers/EditController';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getInpageNormalizedModules } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { getContainers } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { configureStore } from 'InpageEditorUI/redux/configureStore';
import reducer from 'InpageEditorUI/redux/reducers';
import { isPreviewOnly } from 'InpageEditorUI/lib/urlUtils';
import { bindCheckForPendingInpageUpdates } from 'InpageEditorUI/lib/checkForPendingInpageUpdates';
import debugFontsAndIconsLoaded from 'InpageEditorUI/lib/debugFontsAndIconsLoaded';
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { getSidebarIframeWindow } from 'InpageEditorUI/lib/domUtils/sidebarIframeDomUtils';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import lang from 'i2l?query=sporks!../../lang/en.lyaml';
import ReducerDifferManager from 'ContentEditorUI/redux/ReducerDifferManager';
import SyncConfigManager from 'ContentEditorUI/redux/inpageSync/SyncConfigManager';
import inpageActionTypes from 'InpageEditorUI/redux/actions/actionTypes';
let store;
const hsVars = window.hsVars;
export default class Application {
  constructor() {
    this.reactTreeRendered = false;
    this.domReady = false;
    this.sidebarIframeLoaded = false;
    this.isBootstrapped = false;
    this.gates = [];
    this.tellParentAResourceIsBlockingDomReadyAndAppInit = resource => {
      store.dispatch(domReadyBlockingResourceDetected(resource));
    };
    this.tellParentTheIframeIsUnloading = this.tellParentTheIframeIsUnloading.bind(this);
    this.onDomReady = this.onDomReady.bind(this);
    this.onSidebarIframeLoaded = this.onSidebarIframeLoaded.bind(this);
    this.setUpDomReady();
    this.setUpSidebarIframeReady();
    window.hsQueuedLifecycleTimestamps = window.hsQueuedLifecycleTimestamps || {};
  }
  initialize(config = {}) {
    this.eventBus = new EventBus();
    this.inpageConfig = config;
  }
  startPreDomReady() {
    attachCritialAssetHandler();
    attachSlowDomReadyHandler(this.tellParentAResourceIsBlockingDomReadyAndAppInit);
    attachRedirectDetector(this.tellParentTheIframeIsUnloading);
    this.attachReactTreeRenderedAction();
    store = configureStore(reducer, this.eventBus);
    ReducerDifferManager.setStore(store);
    this.eventBus.setStore(store);
    this.editController = new EditController({
      bus: this.eventBus,
      store
    });
    this.bindInpageAppInitializationEvents();
    bindCheckForPendingInpageUpdates(this.eventBus, () => this.allWidgets);
    if (!isPreviewOnly()) {
      this.waitForParentThenBeginInitialization();
    }
    if (window.SELENIUM_IS_RUNNING) {
      debugFontsAndIconsLoaded();
    }
  }

  // Continually check to see if the parent exists, and has set up messaging
  // before we attempt to initialize any further
  waitForParentThenBeginInitialization() {
    // Track when iframe starts waiting for parent
    window.hsQueuedLifecycleTimestamps.PREVIEW_IFRAME_WAITING_ON_PARENT_FRAME = Date.now();
    let messageTimeout = 10;
    const incrementTimeoutBy = 20;
    const maxTimeout = 2000;
    const periodicallyCheckForParent = () => {
      // Continually increase the timeout if we are not getting a response
      messageTimeout += messageTimeout >= maxTimeout ? 0 : incrementTimeoutBy;
      if (this.parentAppReady) {
        this.eventBus.letParentKnowWeGotTheReadyMessage();
        this.eventBus.parentIsReady();
      } else {
        this.eventBus.checkIfParentIsReadyToRecieve();
        setTimeout(periodicallyCheckForParent, messageTimeout);
      }
    };

    // Synchonously check the first time, so if the parent is already ready we don't need to set
    // a timeout that queues our check up behind other JS in the content
    periodicallyCheckForParent();
  }
  startPostDomReady() {
    // Track DOM ready event in iframe
    window.hsQueuedLifecycleTimestamps.PREVIEW_IFRAME_DOMREADY = Date.now();
    if (window.performance.mark) {
      window.performance.mark('PREVIEW_IFRAME_DOMREADY');
    }
    this.eventBus.postMessage({
      action: 'inpageDomReady',
      queuedInpageLifecycleTimestamps: window.hsQueuedLifecycleTimestamps
    });

    // Only watch for critical asset failures before DOM ready (e.g. ignore failed CSS and
    // JS that is inserted after iframe hits domready because further things won't be critial)
    const critialAssetsWithError = collectAndFinishWaitingForCritialAssets();
    if (critialAssetsWithError && critialAssetsWithError.length > 0) {
      store.dispatch(trackedFailedInpageAssets(critialAssetsWithError));
    }
  }
  attachReactTreeRenderedAction() {
    this.eventBus.on('reactTreeRendered', () => {
      this.reactTreeRendered = true;
    });
  }
  onDomReady() {
    this.domReady = true;
  }
  onSidebarIframeLoaded() {
    this.sidebarIframeLoaded = true;
  }
  setUpDomReady() {
    this.domReady = document.readyState === 'complete' || document.readyState === 'interactive';
    if (!this.domReady) {
      document.addEventListener('DOMContentLoaded', this.onDomReady);
    }
  }
  setUpSidebarIframeReady() {
    try {
      const sidebarIframeWindow = getSidebarIframeWindow();
      this.sidebarIframeLoaded = (sidebarIframeWindow === null || sidebarIframeWindow === void 0 ? void 0 : sidebarIframeWindow.document.readyState) === 'complete';
      if (!this.sidebarIframeLoaded) {
        sidebarIframeWindow.document.addEventListener('load', this.onSidebarIframeLoaded);
      }
    } catch (e) {
      this.sidebarIframeLoaded = false;
    }
  }
  bindInpageAppInitializationEvents() {
    this.eventBus.on('post:parentAppMessagingReady', () => {
      this.parentAppReady = true;
    });

    // The parent app knows the language of the user, so this waits for the
    // parent to let the InpageEditor know what the language settings are
    // so that it can load up its own language files.
    this.eventBus.on('post:initializeInpageTranslations', message => {
      const {
        locale,
        langEnabled,
        timezone
      } = message;
      const I18nProvider = createStandardI18nProvider();
      const langFromConfig = this.inpageConfig && this.inpageConfig.lang;
      const extraLangPromise = langFromConfig ? I18nProvider.register(langFromConfig) : Promise.resolve();
      const langAvailable = Promise.all([I18nProvider.register(lang), extraLangPromise, registerAllData(I18nProvider)]);
      langAvailable.then(() => {
        this.editController.i18nInitialized();
      });
      I18nProvider.setLocale({
        locale,
        langEnabled,
        timezone
      });
    });
    this.eventBus.on('post:setContentSchema', message => {
      ReducerDifferManager.clear();
      ReducerDifferManager.setGates(message.gates);
      ReducerDifferManager.mergeToReduxSliceGateLookupMap(message.reduxSliceToGateLookupMap);
      ReducerDifferManager.mergeToReducerTypeMap(message.reducerTypeMap);
      SyncConfigManager.clear();
      this.bootstrap(message);
      const isOnScalableEditor = message.isOnScalableEditor;
      EditorConfigSingleton.setIsOnScalableEditor(isOnScalableEditor);
      EditorConfigSingleton.setHasPermissionsToSave(message.editorConfig.hasPermissionsToSave);
      if (isOnScalableEditor) {
        EditorConfigSingleton.set(Object.assign({}, message.editorConfig, {
          inpage: Object.assign({}, this.inpageConfig)
        }));
        EditorConfigSingleton.setGates(message.gates);
      }
      EditorConfigSingleton.setIsInIframe(true);
      const bootstrappedReduxState = store.getState();
      this.isBootstrapped = true;
      this.gates = message.gates;

      // Read only mode short-circuits the inpage editor's initialization
      if (getIsReadOnlyMode(bootstrappedReduxState)) {
        return;
      }
      this.allWidgets = getInpageNormalizedModules(bootstrappedReduxState);
      this.allContainers = Object.values(getContainers(bootstrappedReduxState)).map(immutableContainer => immutableContainer.toJS());
      const tinyMceGlobals = Object.assign({}, message.tinymceGlobalSettings, {
        absoluteUrl: message.schema.absoluteUrl,
        category: message.schema.category.field_name,
        contentDomain: message.schema.context.active_domain.domain,
        domainIsSsl: message.schema.context.active_domain.isSslOnly,
        appUrl: hsVars != null ? hsVars.app_hs_base_url : '',
        appName: message.appName
      });
      this.editController.start({
        moveableWidgetElements: this.moveableWidgetElements,
        allWidgets: this.allWidgets,
        allContainers: this.allContainers,
        gates: message.gates,
        isTrellisTheme: message.appState.appStatus.isTrellisTheme,
        tinyMceGlobals,
        isBlog: message.schema.category.field_name === 'blog_post',
        moduleMissingErrors: message.schema.module_missing_errors
      });

      // Use interframe callback to let parent know that this iframe is _fully_ loaded
      message.response = {
        iframeFullyLoadedAndBoostraped: true
      };

      // Delete big parts of the original message's payload so they don't have to be re-serialized
      // on the way back
      delete message.appState;
      delete message.schema;
      this.eventBus.postMessage(message);
    });
    this.eventBus.on('post:navigateTo', ({
      url
    }) => {
      detachRedirectDetector();
      window.location.href = url;
    });
    this.eventBus.on('post:setDebugFlag', ({
      flag,
      value
    }) => {
      if (value === false) {
        localStorage.removeItem(flag);
      } else {
        localStorage.setItem(flag, value);
      }
    });
  }
  bootstrap(message) {
    store.dispatch(syncInpageState(message.appState, true));
    this.setExpectedHubSpotGlobals(message);
    // Init content routes - needed for inline editing plugins
    ContentRoutes.init(message.gates);
  }
  setExpectedHubSpotGlobals(message) {
    if (window.hubspot.portal == null) {
      window.hubspot.portal = {};
    }
    window.hubspot.portal.id = message.schema.portalId;
    if (window.hubspot.gates == null) {
      window.hubspot.gates = {};
    }
    if (message.gates != null) {
      Object.assign(window.hubspot.gates, message.gates);
    }
    Object.assign(window.hubspot.bender, message.bender);

    // Leave around a global function so a re-run of IPEUI's JS can let the parent app know
    window.hubspot.trackInpageJsLoadedMultipleTimes = () => {
      store.dispatch(trackedInpageJsLoadingMultipleTimes());
      delete window.hubspot.trackInpageJsLoadedMultipleTimes;
    };
  }
  logError(error) {
    this.eventBus.postMessage({
      action: 'error',
      error: {
        name: error.name,
        message: error.message,
        stack: error.stack
      }
    });
  }
  tellParentTheIframeIsUnloading() {
    store.dispatch(inpagePreviewUnexpectedlyUnloaded());
  }
  manuallyUpdateHoverPositions(payload) {
    store.dispatch({
      type: inpageActionTypes.LAYOUT_SECTION_HOVER_POSITIONS_UPDATED,
      payload
    });
  }
}